import { Header2, LinkButton } from '@cian/ui-kit';
import * as React from 'react';

import * as imgLeftSideLeft from './assets/img_left_side--left.png';
import * as imgLeftSideCenter from './assets/img_left_side--center.png';
import * as imgLeftSideRight from './assets/img_left_side--right.png';
import * as imgRightSideLeft from './assets/img_right_side--left.png';
import * as imgRightSideCenter from './assets/img_right_side--center.png';
import * as imgRightSideRight from './assets/img_right_side--right.png';

import * as styles from './ProfessionalSearchPromo.css';

export interface IProfessionalSearchPromoProps {
  link: string;
  onClick(): void;
}

export const ProfessionalSearchPromo = ({ link, onClick }: IProfessionalSearchPromoProps) => {
  return (
    <div className={styles['banner']}>
      <img className={styles['img_left_side--left']} src={imgLeftSideLeft}></img>
      <img className={styles['img_left_side--center']} src={imgLeftSideCenter}></img>
      <img className={styles['img_left_side--right']} src={imgLeftSideRight}></img>
      <img className={styles['img_right_side--left']} src={imgRightSideLeft}></img>
      <img className={styles['img_right_side--center']} src={imgRightSideCenter}></img>
      <img className={styles['img_right_side--right']} src={imgRightSideRight}></img>
      <div className={styles['content']}>
        <div className={styles['header']}>
          <Header2>
            Профессионалы ищут объекты <span className={styles['name']}>в «Профпоиске»</span>
          </Header2>
        </div>
        <div className={styles['button']}>
          <LinkButton size="XS" href={link} onClick={onClick}>
            Хочу попробовать
          </LinkButton>
        </div>
      </div>
    </div>
  );
};
